import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import { keyByProperty } from '../../../helpers/core';
import Api from '../../../helpers/api';
import { t } from '../../../i18n';

const api = new Api('referrals_settings');

function* loadData() {
  try {
    const result = yield call(sendRequest, api.load, {}, notifications.REQUEST_ERROR);

    if (result?.data?.success) {
      const { data } = result.data.success;

      yield put(actions.loadDataSuccess({ data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* update(data) {
  try {
    const { payload } = data;
    const { editForm } = payload;

    const propsArray = Object.values(editForm);
    const setting = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(sendRequest, api.updateItem, { data: { ...setting } }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      yield put(actions.saveSuccess({ data: setting }));
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.updated_successfully', {
            item: t('dash.admin.referrals.referrals'),
          }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadData, update };
export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.SAVE, update)]);
}
